//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SHORT_DATE_FORMAT } from '@/lib/constants'
import { formatDate } from '@/lib/utils'
import { newPlatformCodes } from '@/lib/platforms'
import { mapState } from 'vuex'

/**
 * A dropdown to select Social Accounts for a platform. Requires a platform
 * prop to specify which platform the accounts are for. The value prop is the
 * ID of the SocialAccount instance.
 */
export default {
  name: 'SocialAccountDropdown',
  props: {
    value: {
      type: String
    },
    platform: {
      type: String,
      validator: (value) => {
        return newPlatformCodes.includes(value)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'is-bottom-right'
    }
  },
  data() {
    return {
      SHORT_DATE_FORMAT,
      inputValue: this.value || '',
      selected: null
    }
  },
  methods: {
    formatDate
  },
  computed: {
    ...mapState(['profile']),
    uppercasePlatform() {
      return this.platform.toUpperCase()
    },
    accounts() {
      if (this.profile) {
        return this.profile.socialAccounts.filter(
          (account) => account.platform === this.uppercasePlatform
        )
      } else {
        return []
      }
    },
    selectedAccount() {
      if (!this.inputValue) {
        return null
      }
      return this.accounts.find((account) => account.id === this.inputValue)
    },
    enabledAccounts() {
      return this.accounts.filter((account) => account.isEnabled)
    }
  },
  watch: {
    inputValue(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
        this.$emit('accountSelected', this.selectedAccount)
      }
    },
    value(val, oldVal) {
      this.inputValue = val
    }
  }
}
